import { apiClient } from "../httpsClient";
import { APIResponse } from "@api/@types";

export interface PresignedUrlPayload {
  contentType: string;
  originalFilename: string;
}

export interface PresignedUrlResponse {
  presignedUrl: string;
  fileUrl: string;
  filename: string;
}

/**
 * presigned URL을 발급받는 API
 * @param payload - 파일 정보 (contentType, originalFilename)
 * @returns 발급된 presigned URL 및 파일 정보
 */
export default async function postPresignedUrl(
  payload: PresignedUrlPayload,
): Promise<APIResponse<PresignedUrlResponse>> {
  const response = apiClient.post<PresignedUrlResponse>(
    "/api/v1/files/presigned-url",
    payload,
  );

  return response;
}
